import React, { Component } from "react";
import { observer } from "mobx-react";
import LayerStore from "../../../../stores/LayerStore";
import img1 from "../../../../static-file/images/step02_img1.png";
import img2 from "../../../../static-file/images/step02_img2.png";
import img3 from "../../../../static-file/images/step02_img3.png";
import img4 from "../../../../static-file/images/step02_img4.png";
import img5 from "../../../../static-file/images/step02_img5.png";
import img6 from "../../../../static-file/images/step02_img6.png";
import img7 from "../../../../static-file/images/step02_img7.png";
import img8 from "../../../../static-file/images/step02_img8.png";
import pre_btn from "../../../../static-file/images/pre_btn.png";
import pre_btn_black from "../../../../static-file/images/pre_btn_black.png";
import next_btn from "../../../../static-file/images/next_btn.png";
import next_btn_black from "../../../../static-file/images/next_btn_black.png";
import BlankIcon from "../../../../static-file/images/logo/blank.png";

@observer
class OnboardingStep_02 extends Component {
  constructor(props) {
    super(props);
    this.state = { cnt: 1 };
    this.rootStore = {
      layerStore: LayerStore,
    };
  }

  cntUp = () => {
    const { rootStore } = this;
    if (this.state.cnt < 8) {
      this.setState({ cnt: this.state.cnt + 1 });
    } else {
      rootStore.layerStore.setChangeOnboardingStep("03");
      this.setState({ cnt: 1 });
    }
  };

  cntDown = () => {
    const { rootStore } = this;
    if (this.state.cnt > 1) {
      this.setState({ cnt: this.state.cnt - 1 });
    } else {
      rootStore.layerStore.setChangeOnboardingStep("01");
      this.setState({ cnt: 1 });
    }
  };

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;

    let img = BlankIcon;
    let prev_icon = BlankIcon;
    let next_icon = BlankIcon;

    if (this.state.cnt === 1) {
      img = img1;
      prev_icon = pre_btn_black;
      next_icon = next_btn;
    } else if (this.state.cnt === 2) {
      img = img2;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 3) {
      img = img3;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 4) {
      img = img4;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 5) {
      img = img5;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 6) {
      img = img6;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 7) {
      img = img7;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 8) {
      img = img8;
      prev_icon = pre_btn;
      next_icon = next_btn_black;
    } else {
      img = BlankIcon;
    }

    return (
      <div
        className={"layer_comm layer_common_type " + (layerStore.getChangeOnboardingStep === "02" ? " layer_open" : "")}
      >
        <div className="bg"></div>
        <div className="layer_content">
          <div className="article_common_type">
            <div className="section">
              <div className="detail">
                <div className="top">
                  <span
                    className="top_txt"
                    onClick={event => {
                      layerStore.setChangeOnboardingStep("");
                      layerStore.setLayerOnboardingView(true);
                      this.setState({ cnt: 1 });
                    }}
                  >
                    &lt; &nbsp; 처음으로
                  </span>
                  <span className="top_sub">&nbsp;&nbsp;&nbsp;Step 02. 배달앱 (배/쿠/요) 주문처리</span>
                </div>
                <div className={this.state.cnt === 1 ? "tit" : "hide"}>
                  <p className="num">
                    <span>1</span>
                  </p>
                  <p className="txt">
                    배달앱 <strong>주문 접수 후</strong>, 고객용 <strong>주문서를 출력</strong>합니다
                  </p>
                </div>
                <div className={this.state.cnt === 2 ? "tit" : "hide"}>
                  <p className="num">
                    <span>2</span>
                  </p>
                  <p className="txt">
                    배달앱 주문 자동접수 처리 <strong>알림을 클릭</strong>합니다.
                    <br />
                    알림 클릭시, 주문상세 팝업으로 이동합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 3 ? "tit" : "hide"}>
                  <p className="num">
                    <span>3</span>
                  </p>
                  <p className="txt">
                    <strong>라이더 호출</strong>이 필요한 경우,<strong> [배달요청] 버튼</strong>을 클릭합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 4 ? "tit" : "hide"}>
                  <p className="num">
                    <span>4</span>
                  </p>
                  <p className="txt">
                    인식된 주소가 불분명할 경우, <strong>주소에러 표시</strong>가 나타납니다.
                    <br />
                    동일 주소 검색하여 <strong>주소수정 후</strong> 라이더 호출을 진행해주세요.
                  </p>
                </div>
                <div className={this.state.cnt === 5 ? "tit" : "hide"}>
                  <p className="num">
                    <span>5</span>
                  </p>
                  <p className="txt">
                    라이더 호출 없이 포스에 <strong>매출 처리만 필요</strong>한 경우,
                    <br />
                    <strong>[완료처리] 버튼</strong>을 클릭하여 완료 주문 처리합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 6 ? "tit" : "hide"}>
                  <p className="num">
                    <span>6</span>
                  </p>
                  <p className="txt">
                    <strong>[전체완료] 버튼</strong>으로 현재 페이지에 있는 주문을
                    <br />
                    <strong>한번에 완료처리</strong>할 수 있습니다.
                  </p>
                </div>
                <div className={this.state.cnt === 7 ? "tit" : "hide"}>
                  <p className="num">
                    <span>7</span>
                  </p>
                  <p className="txt">
                    배달매니저에 <strong>미완료 주문건</strong>이 있으면 <strong>포스 마감이 불가</strong>합니다.
                    <br />
                    <strong className="f">꼭! 주문들을 모두 완료처리 해주세요.</strong>
                  </p>
                </div>
                <div className={this.state.cnt === 8 ? "tit" : "hide"}>
                  <p className="num">
                    <span>8</span>
                  </p>
                  <p className="txt">
                    더 자세한 사항은 <strong>모바일 매뉴얼</strong>을 확인해주세요.
                  </p>
                </div>
                <div className="content">
                  <p className="pre">
                    <span className="btn" onClick={this.cntDown}>
                      <img src={prev_icon} alt={"prevButton"} />
                    </span>
                    <span className={this.state.cnt === 1 ? "txt" : "hide"}>이전 안내</span>
                  </p>
                  <p className="img">
                    <img src={img} alt={"content"} />
                  </p>
                  <p className="next">
                    <span className="btn" onClick={this.cntUp}>
                      <img src={next_icon} alt={"nextButton"} />
                    </span>
                    <span className={this.state.cnt === 8 ? "txt" : "hide"}>다음 안내</span>
                  </p>
                </div>
                <div className="page">
                  <ul className="pagination modal">
                    <li className={this.state.cnt === 1 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 2 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 3 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 4 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 5 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 6 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 7 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 8 ? "location" : "num"}></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="btn_close">
              <button
                onClick={event => {
                  layerStore.setChangeOnboardingStep("");
                  this.setState({ cnt: 1 });
                }}
              >
                <span>닫기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingStep_02;
